import React, { useRef } from 'react'
import { SettingsRow } from "pages/NewSettings/settings-row";
import useTranslation from 'hooks/useTranslation';
import { Fields } from 'uicomponents';
import { get } from 'lodash';
import { Field } from 'formik';
import { QRCodeCanvas } from 'qrcode.react';
import { useSelector } from 'react-redux';
import { AlertOctagon } from "lucide-react";


const TelegramSettings = ({ values, setFieldValue }) => {
  const { tr } = useTranslation();
  const qrRef = useRef(null);

  const profile = useSelector((state) => state.auth.user);
  const role = useSelector(state => get(state.auth, "user.role.role"));

  const downloadQRcode = () => {
    const canvas = qrRef.current;
    if (!canvas) return;
    const dataUrl = canvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = `qr_${(profile && profile.organization_id) || "org"}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <div>
      <SettingsRow title={tr("Статус для телеграм")}>
        <Field
          component={Fields.CheckboxS1}
          name="has_telegram_bot"
          checked={values.has_telegram_bot}
        />
      </SettingsRow>
      <SettingsRow title={tr("Телеграм Чат ID")}>
        <Field
          component={Fields.InputS1}
          name="telegram_chat_id"
          placeholder={tr("Введите")}
          size={"small"}
        />
      </SettingsRow>

      <SettingsRow title={tr("Телеграм бот токен")}>
        <Field
          component={Fields.InputS1}
          name="telegram_bot_token"
          placeholder={tr("Введите")}
          size={"small"}
        />
      </SettingsRow>

      <SettingsRow title={tr("Дополнительная информация в телеграме")}>
        <Field
          component={Fields.TextareaS1}
          name="telegram_info_text"
          placeholder={tr("Введите")}
          size={"small"}
          className={"mb-0"}
          rows={3}
        />
      </SettingsRow>
    </div>
  )
}

export default TelegramSettings